import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgRightAlign = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 16,
	height: 9,
	viewBox: "0 0 16 9",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("path", {
			d: "M15.25 0C15.6642 0 16 0.335786 16 0.75C16 1.16421 15.6642 1.5 15.25 1.5H0.75C0.335787 1.5 0 1.16421 0 0.75C0 0.335786 0.335787 0 0.75 0H15.25Z",
			fill: "#545F7E"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M4.75 9H15.25C15.6642 9 16 8.66421 16 8.25C16 7.83579 15.6642 7.5 15.25 7.5H4.75C4.33579 7.5 4 7.83579 4 8.25C4 8.66421 4.33579 9 4.75 9Z",
			fill: "#545F7E"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M6.625 5.25H15.375C15.7202 5.25 16 4.91421 16 4.5C16 4.08579 15.7202 3.75 15.375 3.75H6.625C6.27982 3.75 6 4.08579 6 4.5C6 4.91421 6.27982 5.25 6.625 5.25Z",
			fill: "#545F7E"
		})
	]
});
const ForwardRef = forwardRef(SvgRightAlign);
export default ForwardRef;
